/**
 * Created by tschenkel on 1/6/2015.
 */


import { BasicSmartfoxConstants } from "../../BasicSmartfoxConstants";
import { BasicCommandVO } from "../../commands/BasicCommandVO";

export class CoreC2SGenerateInviteCodeVO extends BasicCommandVO {
    // Documentation in https://sites.google.com/a/goodgamestudios.com/tech-wiki/java/gamedocumentation/core/events/generateinvitecodeevent

    public T: string; // Type of the friend invite code
    public CC: string; // Country code of inviter
    public RR: string;

    public getCmdId(): string {
        return BasicSmartfoxConstants.C2S_GENERATE_INVITE_CODE;
    }

    /**
     * VO used to generate a invite code for the logged user.
     * @param inviteCodeType String Specify the type of code that will be generated. Accepted values are 'code' or 'link'
     * @param countryCode String Specify the country code of the inviter.
     */
    constructor(inviteCodeType: string = "code", countryCode: string = null) {
        super();
        this.T = inviteCodeType;
        this.CC = countryCode;
        this.RR = "html5";
    }
}

